import { useEffect } from "react";
import { useRouter } from "next/router";

/**
 * Redirect to editor or within the app based on the `/system` url prefix
 *
 * TODO: Replace this
 */
const useEditorRedirect = () => {
  const router = useRouter();
  const {
    query: { redirect },
    pathname,
  } = router;

  useEffect(() => {
    if (pathname === redirect || !redirect) {
      return;
    }

    if (redirect && typeof redirect === "string") {
      if (redirect.startsWith("/system")) {
        window.location.href = `https://${window.location.hostname}${redirect}`;
      } else {
        router.push(redirect);
      }
    }
  }, [pathname, redirect, router]);
};

export default useEditorRedirect;
